import sampleSize from "lodash.samplesize";
import { useEffect, useMemo, useState } from "react";

import RelatedCities from "@/pages/city/related-cities";

import type { CityType } from "../types";
import AllCitiesCard from "./all-cities-card";

const CITIES_COUNT = 7;

interface NearbyCitiesProps {
  cities: CityType[];
}

export default function NearbyCities({ cities: allCities }: NearbyCitiesProps) {
  const [cities, setCities] = useState<CityType[]>([]);

  const ariaLabels = useMemo(() => {
    const labels = cities.map((city) => city.attributes.nameShort);
    labels.push("View all cities");
    return labels;
  }, [cities]);

  useEffect(() => setCities(sampleSize(allCities, CITIES_COUNT)), [allCities]);

  if (!cities.length) {
    return null;
  }

  return (
    <RelatedCities
      ariaLabels={ariaLabels}
      cities={cities}
      count={cities.length + 1}
      title="Best Escape Rooms"
    >
      <AllCitiesCard />
    </RelatedCities>
  );
}
